module.exports = __webpack_public_path__ + "img/services_main_section_back.5d3be3bf.jpg";